import React from 'react'
import { useState, useContext } from 'react';
import { Context } from '../../Context/Context';
import { signIn, updatePassword } from 'aws-amplify/auth';
import { Link, useNavigate } from 'react-router-dom';
import Logo from 'Components/Icons/Logo';
import { CLIENT, PROFESSIONAL, resetPasswordAsAdminApi } from 'Constants';
import InputElement from 'Components/Element/InputElement';
import FormErrorBanner from 'Components/Element/FormErrorBanner';
import SigninHeader from './SigninHeader';


function ResetPassword() {
  const {userDetails, makeApiCallFunc} = useContext(Context);
  const [showPassword, setShowPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const updatePasswordFunc = async() => {
     if(oldPassword && newPassword && confirmPassword && newPassword === confirmPassword && email) 
      {
          makeApiCallFunc(resetPasswordAsAdminApi,{
            username: email,
            password: oldPassword,
            newPassword: newPassword
          },
        async (data) => {
         console.log(data);
         if(data.name === "NotAuthorizedException")
         {
            setError("Incorrect password");
            return;
         }
         else
         {
          setSuccessMsg("Password updated successfully");
         }
          try {
            const signinUser = await signIn({username: email, password: newPassword});
          console.log(signinUser);
          navigate(userDetails?.role === PROFESSIONAL ? "/attorney/profile" : ( userDetails?.role === CLIENT ? "/client/profile" : "/admin/profile" ));
          } catch (error) {
            console.log(error);
            setError("Error logging in. Please login manually.");
            navigate("/signin");
          }
          
        },  
        (data) => {
          console.log(data); 
          
        },
        null,
        false,
        true
        )
      
      }
      else if(newPassword !== confirmPassword) {
          setError("Passwords do not match");
      }
      else if(!oldPassword || !newPassword || !confirmPassword) {
          setError("Please fill all the fields");
      }
  }
return (
  <div className="h-full w-full">
    <SigninHeader/>
    <div className="h-full  ">
        
    <div className="font-medium w-full  bg-white border-r border-1 h-full flex flex-col items-start  ">
     
  <div className="font-medium w-full h-full flex flex-col items-center justify-start mt-24 ">
        
      <div className='text-lg mt-4 text-sky-600 mb-2'>Reset your password to complete registration</div>
      {successMsg ? <div className="text-green-600 mb-10 font-bold text-sm">{successMsg ? successMsg : ''}</div> : ""}

      <FormErrorBanner>{error}</FormErrorBanner>
      
      <div className='w-[520px]'>
            <InputElement
                handleChange={(e) => setEmail(e.target.value)}
                label = "Enter your registered email address"
                labelStyle={" font-bold"}
                handleFocus={() => setError("")}
                name = "email"
                placeholder= "example@email.com"
                value = {email}
            />
          <label htmlFor="password" className="block mt-2 text-sm font-medium leading-6 text-gray-900">
          Password
          </label>
          <div className="relative mt-2 rounded-md shadow-sm">
              <input
                  type= "password"
                  name="password"
                  
                  className="block w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 rounded-md border-0 py-1 pl-3 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  sm:text-sm sm:leading-6"
                  placeholder="Password"
                  onChange={(e)=>setOldPassword(e.target.value)}
                  //onBlur={handleBlur}
                  //value={values.password}
                  //onFocus={() => setApiError("")}
                  value = {oldPassword}
              />
          
          </div>
          <label htmlFor="password" className="block mt-2 text-sm font-medium leading-6 text-gray-900">
          New Password
          </label>
          <div className="relative mt-2 rounded-md shadow-sm">
              <input
                  type={!showPassword? "password" : "text"}
                  name="password"
                  
                  className="block w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 rounded-md border-0 py-1 pl-3 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  sm:text-sm sm:leading-6"
                  placeholder="Password"
                  onChange={(e)=>setNewPassword(e.target.value)}
                  //onBlur={handleBlur}
                  //value={values.password}
                  //onFocus={() => setApiError("")}
                  value = {newPassword}
              />
          <div className="absolute inset-y-0 right-0 flex mr-2 items-center">
              {!showPassword?
              <div onClick={() => setShowPassword(!showPassword)}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                      <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
                      <path fillRule="evenodd" d="M.664 10.59a1.651 1.651 0 010-1.186A10.004 10.004 0 0110 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0110 17c-4.257 0-7.893-2.66-9.336-6.41zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                  </svg>
              </div>
              :
              <div onClick={() => setShowPassword(!showPassword)}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                      <path fillRule="evenodd" d="M3.28 2.22a.75.75 0 00-1.06 1.06l14.5 14.5a.75.75 0 101.06-1.06l-1.745-1.745a10.029 10.029 0 003.3-4.38 1.651 1.651 0 000-1.185A10.004 10.004 0 009.999 3a9.956 9.956 0 00-4.744 1.194L3.28 2.22zM7.752 6.69l1.092 1.092a2.5 2.5 0 013.374 3.373l1.091 1.092a4 4 0 00-5.557-5.557z" clipRule="evenodd" />
                      <path d="M10.748 13.93l2.523 2.523a9.987 9.987 0 01-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 010-1.186A10.007 10.007 0 012.839 6.02L6.07 9.252a4 4 0 004.678 4.678z" />
                  </svg>
              </div>
              }
          </div>
          </div>
          {/* {errors.password && touched.password ? (
                      <p className="text-red-600 mt-2 text-sm">{errors.password}</p>
                  ) : ""}
            */}
            <label htmlFor="password" className="block mt-2 text-sm font-medium leading-6 text-gray-900">
          Confirm Password
          </label>
          <div className="relative mt-2 rounded-md shadow-sm">
              <input
                  type= "password"
                  name="password"
                  
                  className="block w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 rounded-md border-0 py-1 pl-3 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  sm:text-sm sm:leading-6"
                  placeholder="Password"
                  onChange={(e)=>setConfirmPassword(e.target.value)}
                  //onBlur={handleBlur}
                  //value={values.password}
                  //onFocus={() => setApiError("")}
                  value = {confirmPassword}
              />
          </div>
          <div className='flex font-normal text-sm justify-between mt-5'>
              <div 
                  className="w-auto px-5 h-8 bg-sky-500 hover:bg-sky-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl"
                  onClick={updatePasswordFunc}>Change Password</div>
                <div className=" flex justify-center cursor-pointer mt-5 font-normal text-sm">
                    <Link to="/signin" className="underline underline-offset-2 decoration-sky-500" > &lt;- Back to Home </Link>
                </div>  
          </div>
      </div>
  </div>
  </div>
  </div>
  </div>
)
}

export default ResetPassword